var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.index == 1)?_c('i',{staticClass:"icon iconfont iconzu657"}):_vm._e(),(_vm.index == 2)?_c('i',{staticClass:"icon iconfont iconheader_icon_download"}):_vm._e(),(_vm.index == 3)?_c('i',{staticClass:"icon iconfont iconzu657"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }